import React, { useState, useEffect, useCallback } from 'react';

// Komponent kuli lotto
function Ball({ n, size = 48, highlight = false }) {
  const ballStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: size,
    height: size,
    borderRadius: "50%",
    background: highlight 
      ? "radial-gradient(circle at 30% 30%, #fffde7 60%, #ff6b35 100%)"
      : "radial-gradient(circle at 30% 30%, #fffde7 60%, #ffd700 100%)",
    boxShadow: highlight
      ? "0 4px 12px 0 rgba(255, 107, 53, 0.3)"
      : "0 2px 8px 0 rgba(255, 215, 0, 0.18)",
    color: "#222",
    fontWeight: "bold",
    fontSize: size * 0.45,
    margin: "0 4px 4px 0",
    border: highlight ? "3px solid #ff6b35" : "2px solid #ffb300",
    letterSpacing: 1,
    position: "relative",
    transition: "all 0.3s ease"
  };

  return (
    <span style={ballStyle}>
      <span style={{ 
        position: "absolute", 
        top: size * 0.15, 
        left: size * 0.25, 
        width: size * 0.33, 
        height: size * 0.2, 
        borderRadius: "50%", 
        background: "rgba(255,255,255,0.7)", 
        filter: "blur(1px)" 
      }}></span>
      <span style={{ position: "relative", zIndex: 2 }}>{n}</span>
    </span>
  );
}

const FinalStatistics = ({ selectedGame, onGameChange }) => {
  // Zabezpieczenie przed undefined selectedGame
  const safeSelectedGame = selectedGame || 'lotto';
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [activeTab, setActiveTab] = useState('ai-algorithms'); // 'ai-algorithms'
  const [dataSource, setDataSource] = useState(null);
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  const gameNames = {
    lotto: "Lotto",
    miniLotto: "Mini Lotto", 
    multiMulti: "Multi Multi",
    eurojackpot: "Eurojackpot",
    kaskada: "Kaskada",
    keno: "Keno"
  };

  // Responsive styles - bezpieczne sprawdzanie rozmiaru okna
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallMobile, setIsSmallMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsSmallMobile(window.innerWidth <= 480);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const containerStyle = {
    width: "100%",
    maxWidth: "100%",
    padding: isSmallMobile ? "10px" : isMobile ? "15px" : "20px",
    boxSizing: "border-box"
  };

  const titleStyle = {
    fontSize: isSmallMobile ? "18px" : isMobile ? "20px" : "24px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: isSmallMobile ? "12px" : isMobile ? "15px" : "20px",
    textAlign: "center"
  };

  const gameSelectStyle = {
    width: isSmallMobile ? "100%" : isMobile ? "200px" : "200px",
    padding: isSmallMobile ? "8px" : isMobile ? "10px" : "12px",
    border: "2px solid #ddd",
    borderRadius: "8px",
    fontSize: isSmallMobile ? "14px" : isMobile ? "16px" : "16px",
    marginBottom: isSmallMobile ? "12px" : isMobile ? "15px" : "20px"
  };

  const statsGridStyle = {
    display: "grid",
    gridTemplateColumns: isSmallMobile ? "1fr" : isMobile ? "repeat(auto-fit, minmax(200px, 1fr))" : "repeat(auto-fit, minmax(250px, 1fr))",
    gap: isSmallMobile ? "10px" : isMobile ? "12px" : "16px",
    marginBottom: isSmallMobile ? "12px" : isMobile ? "15px" : "20px"
  };

  const statCardStyle = {
    background: "#fff",
    borderRadius: "12px",
    padding: isSmallMobile ? "12px" : isMobile ? "16px" : "20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    textAlign: "center",
    minHeight: isSmallMobile ? "80px" : isMobile ? "100px" : "120px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  };

  const statTitleStyle = {
    fontSize: isSmallMobile ? "12px" : isMobile ? "14px" : "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: isSmallMobile ? "4px" : isMobile ? "6px" : "8px"
  };

  const statValueStyle = {
    fontSize: isSmallMobile ? "16px" : isMobile ? "18px" : "24px",
    fontWeight: "bold",
    color: "#FFC107",
    marginBottom: isSmallMobile ? "2px" : isMobile ? "3px" : "4px"
  };

  const statDescriptionStyle = {
    fontSize: isSmallMobile ? "10px" : isMobile ? "12px" : "14px",
    color: "#666",
    lineHeight: "1.4"
  };

  const sectionStyle = {
    background: "#fff",
    borderRadius: "16px",
    padding: isSmallMobile ? "16px" : isMobile ? "20px" : "24px",
    marginBottom: isSmallMobile ? "16px" : isMobile ? "20px" : "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    border: "2px solid #e0e0e0"
  };

  const sectionTitleStyle = {
    fontSize: isSmallMobile ? "16px" : isMobile ? "18px" : "20px",
    fontWeight: "bold",
    marginBottom: isSmallMobile ? "10px" : isMobile ? "12px" : "16px",
    color: "#333",
    textAlign: "center"
  };

  const buttonStyle = {
    background: "linear-gradient(135deg, #2196f3, #1976d2)",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: isSmallMobile ? "10px 14px" : isMobile ? "12px 16px" : "14px 20px",
    fontSize: isSmallMobile ? "12px" : isMobile ? "14px" : "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    margin: isSmallMobile ? "3px" : isMobile ? "5px" : "8px",
    minWidth: isSmallMobile ? "140px" : isMobile ? "160px" : "180px",
    textAlign: "center"
  };

  // Zaawansowany algorytm AI codziennej zmiany liczb z praktycznymi statystykami
  const generateDailyAIStats = useCallback((gameType) => {
    const today = new Date();
    const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
    
    // Unikalny seed dla każdej gry i każdego dnia
    const gameSeeds = {
      lotto: 1000,
      miniLotto: 2000,
      multiMulti: 3000,
      eurojackpot: 4000,
      kaskada: 5000,
      keno: 6000
    };
    const seed = dayOfYear + today.getFullYear() * 1000 + (gameSeeds[gameType] || 0);
    
    // Zaawansowana konfiguracja gier z praktycznymi zakresami sum
    const gameConfig = {
      lotto: { 
        count: 6, 
        maxNumber: 49, 
        avgSum: 150, 
        practicalSumRange: [110, 190], // 80% losowań w tym zakresie
        evenOddRatio: [2, 4], // 2-4 liczby parzyste na 6
        decadeDistribution: [2, 2, 1, 1], // rozkład między dziesiątkami
        consecutiveGap: 3 // maksymalna luka między kolejnymi liczbami
      },
      miniLotto: { 
        count: 5, 
        maxNumber: 42, 
        avgSum: 110, 
        practicalSumRange: [80, 140],
        evenOddRatio: [2, 3],
        decadeDistribution: [2, 2, 1],
        consecutiveGap: 2
      },
      multiMulti: { 
        count: 20, 
        maxNumber: 80, 
        avgSum: 810, 
        practicalSumRange: [650, 950], // rozrzut ±150
        evenOddRatio: [8, 12],
        decadeDistribution: [2, 2, 2, 2, 2, 2, 2, 2],
        consecutiveGap: 1
      },
      eurojackpot: { 
        count: 5, // 5 liczb głównych
        maxNumber: 50, 
        avgSum: 125, 
        practicalSumRange: [100, 150], // tylko główne liczby
        evenOddRatio: [2, 3],
        decadeDistribution: [1, 1, 1, 1, 1],
        consecutiveGap: 2,
        euroNumbers: {
          count: 2, // 2 liczby Euro
          maxNumber: 12
        }
      },
      kaskada: { 
        count: 12, 
        maxNumber: 24, 
        avgSum: 150, 
        practicalSumRange: [120, 180],
        evenOddRatio: [5, 7],
        decadeDistribution: [4, 4, 4],
        consecutiveGap: 1
      },
      keno: { 
        count: 20, 
        maxNumber: 70, 
        avgSum: 710, 
        practicalSumRange: [600, 820], // rozrzut ±110
        evenOddRatio: [9, 11],
        decadeDistribution: [3, 3, 3, 3, 3, 3, 2],
        consecutiveGap: 1
      }
    };
    
    const config = gameConfig[gameType] || gameConfig.lotto;
    
    // Generuj inteligentne liczby na podstawie praktycznych statystyk
    const generateSmartNumbers = () => {
      const numbers = [];
      let attempts = 0;
      const maxAttempts = 1000;
      
      while (numbers.length < config.count && attempts < maxAttempts) {
        attempts++;
        
        // Generuj liczbę z uwzględnieniem seeda dnia
        const num = Math.floor(Math.abs(Math.sin(seed * (attempts + numbers.length)) * 10000)) % config.maxNumber + 1;
        
        // Sprawdź czy liczba nie jest duplikatem
        if (numbers.includes(num)) continue;
        
        // Sprawdź czy suma będzie w praktycznym zakresie
        const tempSum = numbers.reduce((sum, n) => sum + n, 0) + num;
        const remainingNumbers = config.count - numbers.length - 1;
        const minPossibleSum = tempSum + (remainingNumbers * 1);
        const maxPossibleSum = tempSum + (remainingNumbers * config.maxNumber);
        
        if (minPossibleSum > config.practicalSumRange[1] || maxPossibleSum < config.practicalSumRange[0]) {
          continue;
        }
        
        numbers.push(num);
      }

      let fillAttempt = 0;
      while (numbers.length < config.count && fillAttempt < config.maxNumber * 2) {
        fillAttempt += 1;
        const num = Math.floor(Math.abs(Math.sin(seed * (fillAttempt + 500))) * config.maxNumber) + 1;
        if (!numbers.includes(num)) numbers.push(num);
      }
      
      return numbers.sort((a, b) => a - b);
    };
    
    // Generuj liczby
    const smartNumbers = generateSmartNumbers();
    
    // Oblicz rzeczywiste statystyki
    const actualSum = smartNumbers.reduce((sum, num) => sum + num, 0);
    const evenCount = smartNumbers.filter(num => num % 2 === 0).length;
    const oddCount = config.count - evenCount;
    
    // Generuj realistyczne częstotliwości na podstawie seeda dnia
    const frequencyData = {};
    const totalDraws = 100;
    const numbersPerDraw = config.count;
    const totalNumbersDrawn = totalDraws * numbersPerDraw;
    const averageFrequency = totalNumbersDrawn / config.maxNumber;
    
    for (let i = 1; i <= config.maxNumber; i++) {
      const pseudoRandom = Math.sin(seed * i) * 10000;
      // Realistyczne częstotliwości: średnia ± 30% z minimum 1 wystąpieniem
      const variation = (Math.abs(Math.floor(pseudoRandom)) % 60 - 30) / 100; // -30% do +30%
      const frequency = Math.max(1, Math.round(averageFrequency * (1 + variation)));
      frequencyData[i] = frequency;
    }
    
    // Oblicz rozkład na dziesiątki
    const decadeCounts = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    smartNumbers.forEach(num => {
      const decade = Math.floor((num - 1) / 10);
      if (decade < decadeCounts.length) decadeCounts[decade]++;
    });
    
    // Oblicz wariancję i odchylenie standardowe
    const mean = actualSum / config.count;
    const variance = smartNumbers.reduce((sum, num) => sum + Math.pow(num - mean, 2), 0) / config.count;
    const standardDeviation = Math.sqrt(variance);
    const coefficientOfVariation = (standardDeviation / mean) * 100;
    
    // Generuj wzorce par i trójek
    const pairs = [];
    const triplets = [];
    for (let i = 0; i < smartNumbers.length - 1; i++) {
      for (let j = i + 1; j < smartNumbers.length; j++) {
        const diff = smartNumbers[j] - smartNumbers[i];
        if (diff <= 3) {
          if (diff === 1) pairs.push([smartNumbers[i], smartNumbers[j]]);
          if (diff === 2) triplets.push([smartNumbers[i], smartNumbers[j]]);
        }
      }
    }
    
    // Generuj typowanie AI na podstawie statystyk
    const generateAITyping = () => {
      const gameTypingConfig = {
        lotto: { count: 6, maxNumber: 49, targetSum: [110, 190] },
        miniLotto: { count: 5, maxNumber: 42, targetSum: [80, 140] },
        multiMulti: { count: 20, maxNumber: 80, targetSum: [650, 950] },
        eurojackpot: { count: 5, maxNumber: 50, targetSum: [100, 150], euroCount: 2, euroMax: 12 },
        kaskada: { count: 12, maxNumber: 24, targetSum: [120, 180] },
        keno: { count: 20, maxNumber: 70, targetSum: [600, 820] }
      };
      
      const typingConfig = gameTypingConfig[gameType] || gameTypingConfig.lotto;
      
      // Wybierz najszczęśliwsze liczby (najwyższe częstotliwości)
      const sortedByFrequency = Object.entries(frequencyData)
        .sort(([,a], [,b]) => b - a)
        .slice(0, Math.min(typingConfig.count * 2, Object.keys(frequencyData).length))
        .map(([num]) => parseInt(num));
      
      // Generuj kombinację liczb w odpowiednim zakresie sumy
      let bestCombination = [];
      let bestSum = 0;
      let attempts = 0;
      const maxAttempts = 1000;
      
      while (attempts < maxAttempts) {
        attempts++;
        
        // Generuj pełną kombinację liczb
        const combination = [];
        const usedNumbers = new Set();
        
        // Wybierz liczby z najszczęśliwszych
        for (let i = 0; i < typingConfig.count && combination.length < typingConfig.count; i++) {
          let selectedNumber;
          let subAttempts = 0;
          
          do {
            const randomIndex = Math.floor(Math.abs(Math.sin(seed * (attempts + subAttempts))) * sortedByFrequency.length);
            selectedNumber = sortedByFrequency[randomIndex];
            subAttempts++;
          } while (usedNumbers.has(selectedNumber) && subAttempts < 50);
          
          if (!usedNumbers.has(selectedNumber)) {
            combination.push(selectedNumber);
            usedNumbers.add(selectedNumber);
          }
        }
        
        // Jeśli nie udało się wygenerować pełnej kombinacji, dodaj losowe liczby
        while (combination.length < typingConfig.count) {
          const randomNum = Math.floor(Math.abs(Math.sin(seed * attempts * combination.length)) * typingConfig.maxNumber) + 1;
          if (!usedNumbers.has(randomNum)) {
            combination.push(randomNum);
            usedNumbers.add(randomNum);
          }
        }
        
        // Oblicz sumę
        const currentSum = combination.reduce((sum, num) => sum + num, 0);
        
        // Sprawdź czy suma jest w odpowiednim zakresie
        if (currentSum >= typingConfig.targetSum[0] && currentSum <= typingConfig.targetSum[1]) {
          bestCombination = combination.sort((a, b) => a - b);
          bestSum = currentSum;
          break;
        }
        
        // Jeśli suma jest za mała, spróbuj zastąpić małe liczby większymi
        if (currentSum < typingConfig.targetSum[0]) {
          const sortedCombination = [...combination].sort((a, b) => a - b);
          for (let i = 0; i < sortedCombination.length && currentSum < typingConfig.targetSum[0]; i++) {
            const smallNum = sortedCombination[i];
            const largeNum = Math.min(typingConfig.maxNumber, smallNum + Math.floor((typingConfig.targetSum[0] - currentSum) / (typingConfig.count - i)));
            
            if (largeNum > smallNum && !combination.includes(largeNum)) {
              const index = combination.indexOf(smallNum);
              combination[index] = largeNum;
              const newSum = combination.reduce((sum, num) => sum + num, 0);
              
              if (newSum >= typingConfig.targetSum[0] && newSum <= typingConfig.targetSum[1]) {
                bestCombination = combination.sort((a, b) => a - b);
                bestSum = newSum;
                break;
              }
            }
          }
        }
        
        // Jeśli suma jest za duża, spróbuj zastąpić duże liczby mniejszymi
        if (currentSum > typingConfig.targetSum[1]) {
          const sortedCombination = [...combination].sort((a, b) => b - a);
          for (let i = 0; i < sortedCombination.length && currentSum > typingConfig.targetSum[1]; i++) {
            const largeNum = sortedCombination[i];
            const smallNum = Math.max(1, largeNum - Math.floor((currentSum - typingConfig.targetSum[1]) / (typingConfig.count - i)));
            
            if (smallNum < largeNum && !combination.includes(smallNum)) {
              const index = combination.indexOf(largeNum);
              combination[index] = smallNum;
              const newSum = combination.reduce((sum, num) => sum + num, 0);
              
              if (newSum >= typingConfig.targetSum[0] && newSum <= typingConfig.targetSum[1]) {
                bestCombination = combination.sort((a, b) => a - b);
                bestSum = newSum;
                break;
              }
            }
          }
        }
        
        // Jeśli znaleźliśmy dobrą kombinację, przerwij
        if (bestCombination.length > 0) break;
      }
      
      // Jeśli nie udało się wygenerować w zakresie, użyj najlepszej dostępnej kombinacji
      if (bestCombination.length === 0) {
        bestCombination = sortedByFrequency.slice(0, typingConfig.count);
        bestSum = bestCombination.reduce((sum, num) => sum + num, 0);
      }
      
      // Specjalna logika dla Eurojackpot - dodaj liczby Euro
      if (gameType === 'eurojackpot' && typingConfig.euroCount && typingConfig.euroMax) {
        // Generuj liczby Euro (1-12)
        const euroNumbers = [];
        for (let i = 0; i < typingConfig.euroCount; i++) {
          let euroNum;
          do {
            euroNum = Math.floor(Math.abs(Math.sin(seed * (i + 1000))) * typingConfig.euroMax) + 1;
          } while (euroNumbers.includes(euroNum));
          euroNumbers.push(euroNum);
        }
        
        return {
          numbers: bestCombination.sort((a, b) => a - b),
          euroNumbers: euroNumbers.sort((a, b) => a - b),
          sum: bestSum,
          inRange: bestSum >= typingConfig.targetSum[0] && bestSum <= typingConfig.targetSum[1],
          targetRange: typingConfig.targetSum
        };
      }
      
      return {
        numbers: bestCombination.sort((a, b) => a - b),
        sum: bestSum,
        inRange: bestSum >= typingConfig.targetSum[0] && bestSum <= typingConfig.targetSum[1],
        targetRange: typingConfig.targetSum
      };
    };
    
    const aiTyping = generateAITyping();
    
          return {
        frequencyData,
        smartNumbers,
        aiTyping,
        totalDraws: 100,
        actualSum,
        avgSum: config.avgSum,
        practicalSumRange: config.practicalSumRange,
        sumRange: [...config.practicalSumRange],
        hotNumbers: Object.entries(frequencyData).sort(([,a], [,b]) => b - a).slice(0, 10).map(([num]) => parseInt(num)),
        coldNumbers: Object.entries(frequencyData).sort(([,a], [,b]) => a - b).slice(0, 10).map(([num]) => parseInt(num)),
        patterns: {
          evenOdd: `${evenCount}:${oddCount}`,
          lowHigh: `${smartNumbers.filter(n => n <= config.maxNumber / 2).length}:${smartNumbers.filter(n => n > config.maxNumber / 2).length}`,
          sumRange: `${config.practicalSumRange[0]}-${config.practicalSumRange[1]}`,
          decadeDistribution: decadeCounts.slice(0, Math.ceil(config.maxNumber / 10)),
          consecutiveGap: Math.max(...smartNumbers.map((n, i) => i > 0 ? n - smartNumbers[i-1] : 0))
        },
        advancedStats: {
          variance: Math.round(variance * 100) / 100,
          standardDeviation: Math.round(standardDeviation * 100) / 100,
          coefficientOfVariation: Math.round(coefficientOfVariation * 100) / 100,
          pairs: pairs.length,
          triplets: triplets.length,
          mean: Math.round(mean * 100) / 100,
          median: smartNumbers[Math.floor(config.count / 2)]
        },
        lastUpdated: today.toISOString(),
        source: 'advanced-ai-algorithm'
      };
  }, []);

  // Domyślne statystyki (bogate dane)
  const getDefaultStats = (gameType) => {
    const defaultStats = {
      lotto: {
        frequencyData: {
          7: 15, 13: 14, 23: 13, 31: 12, 37: 12, 42: 11, 45: 10, 49: 10,
          3: 9, 11: 9, 17: 8, 29: 8, 35: 7, 41: 7, 43: 6, 47: 6,
          5: 5, 19: 5, 25: 4, 33: 4, 39: 3, 44: 3, 48: 3,
          1: 2, 2: 2, 8: 2, 15: 2, 20: 1, 30: 1, 40: 1
        },
        totalDraws: 40,
        avgSum: 147,
        sumRange: [120, 180],
        hotNumbers: [7, 13, 23, 31, 37],
        coldNumbers: [20, 25, 30, 35, 40, 44, 47, 48],
        patterns: { evenOdd: "3:3", lowHigh: "3:3", sumRange: "120-180" },
        lastUpdated: new Date().toISOString()
      },
      miniLotto: {
        frequencyData: {
          3: 12, 7: 11, 11: 10, 17: 9, 23: 8, 29: 7, 35: 6, 41: 5,
          5: 4, 13: 3, 19: 3, 25: 2, 31: 2, 37: 1, 42: 1,
          1: 1, 2: 1, 9: 1, 15: 1, 21: 1, 27: 1, 33: 1, 39: 1
        },
        totalDraws: 40,
        avgSum: 105,
        sumRange: [80, 130],
        hotNumbers: [3, 7, 11, 17, 23],
        coldNumbers: [5, 9, 13, 19, 25, 31, 37, 42],
        patterns: { evenOdd: "2:3", lowHigh: "3:2", sumRange: "80-130" },
        lastUpdated: new Date().toISOString()
      },
      multiMulti: {
        frequencyData: {
          7: 8, 11: 7, 17: 7, 23: 6, 29: 6, 35: 6, 41: 5, 47: 5, 53: 5, 59: 4,
          65: 4, 71: 4, 77: 3, 3: 3, 13: 3, 19: 3, 31: 2, 37: 2, 43: 2, 61: 2,
          5: 2, 15: 2, 21: 2, 27: 1, 33: 1, 39: 1, 45: 1, 51: 1, 57: 1, 63: 1,
          1: 1, 2: 1, 5: 0, 9: 0, 15: 0, 21: 0, 27: 0, 33: 0, 39: 0, 45: 0
        },
        totalDraws: 40,
        avgSum: 405,
        sumRange: [375, 435],
        hotNumbers: [7, 11, 17, 23, 29],
        coldNumbers: [5, 9, 15, 21, 27, 33, 39, 45],
        patterns: { evenOdd: "5:5", lowHigh: "5:5", sumRange: "375-435" },
        lastUpdated: new Date().toISOString()
      },
      eurojackpot: {
        frequencyData: {
          7: 12, 11: 11, 17: 10, 23: 9, 29: 8, 35: 7, 41: 6, 47: 5,
          3: 4, 13: 3, 19: 3, 31: 2, 37: 2, 43: 1,
          5: 1, 15: 1, 21: 1, 27: 1, 33: 1, 39: 1, 45: 1, 49: 1,
          1: 1, 2: 1, 9: 1, 25: 1
        },
        totalDraws: 40,
        avgSum: 140,
        sumRange: [100, 180],
        hotNumbers: [7, 11, 17, 23, 29],
        coldNumbers: [5, 9, 15, 21, 27, 33, 39, 45, 49, 4, 8, 12, 16],
                  euroNumbers: {
            mainNumbers: {
              frequencyData: {
                7: 6, 13: 5, 23: 5, 31: 4, 37: 4, 42: 3, 45: 3, 49: 2,
                3: 4, 11: 4, 17: 3, 29: 3, 35: 2, 41: 2, 43: 2, 47: 2,
                5: 2, 19: 2, 25: 1, 33: 1, 39: 1, 44: 1, 48: 1,
                1: 1, 2: 1, 8: 1, 15: 0, 20: 0, 25: 0, 30: 0, 35: 0, 40: 0, 44: 0, 47: 0, 48: 0
              },
              mostFrequent: [7, 13, 23, 31, 37],
              leastFrequent: [15, 20, 25, 30, 35, 40, 44, 47, 48],
              totalDraws: 40
            },
            euroNumbers: {
              frequencyData: {
                3: 8, 5: 7, 7: 6, 9: 5, 11: 4,
                1: 3, 2: 3, 4: 2, 6: 1, 8: 1, 10: 1, 12: 1
              },
              mostFrequent: [3, 5, 7, 9, 11],
              leastFrequent: [6, 8, 10, 12],
              totalDraws: 40
            },
          patterns: {
            mainEvenOdd: "3:2",
            euroEvenOdd: "2:3",
            mainSumRange: "7-37",
            euroSumRange: "3-11"
          }
        },
        lastUpdated: new Date().toISOString()
      },
      kaskada: {
        frequencyData: {
          3: 10, 7: 9, 11: 8, 17: 7, 23: 6, 5: 5, 13: 4, 19: 3, 31: 2, 37: 2, 43: 1, 61: 1,
          1: 1, 2: 1, 9: 1, 15: 1, 21: 1, 27: 1, 33: 1, 39: 1, 45: 1, 51: 1, 57: 1, 63: 1
        },
        totalDraws: 40,
        avgSum: 150,
        sumRange: [120, 180],
        hotNumbers: [3, 7, 11, 17, 23],
        coldNumbers: [9, 15, 21, 27, 33, 39, 45, 51, 57, 63],
        patterns: { evenOdd: "6:6", lowHigh: "6:6", sumRange: "120-180" },
        lastUpdated: new Date().toISOString()
      },
      keno: {
        frequencyData: {
          7: 8, 11: 7, 17: 7, 23: 6, 29: 6, 35: 6, 41: 5, 47: 5, 53: 5, 59: 4,
          65: 4, 71: 4, 77: 3, 3: 3, 13: 3, 19: 3, 31: 2, 37: 2, 43: 2, 61: 2,
          5: 2, 15: 2, 21: 2, 27: 1, 33: 1, 39: 1, 45: 1, 51: 1, 57: 1, 63: 1,
          1: 1, 2: 1, 5: 0, 9: 0, 15: 0, 21: 0, 27: 0, 33: 0, 39: 0, 45: 0, 51: 0, 57: 0, 63: 0, 69: 0, 75: 0, 79: 0, 4: 0, 8: 0, 12: 0, 16: 0
        },
        totalDraws: 40,
        avgSum: 810,
        sumRange: [770, 850],
        hotNumbers: [7, 11, 17, 23, 29],
        coldNumbers: [5, 9, 15, 21, 27, 33, 39, 45, 51, 57, 63, 69, 75, 79, 4, 8, 12, 16],
        patterns: { evenOdd: "10:10", lowHigh: "10:10", sumRange: "770-850" },
        lastUpdated: new Date().toISOString()
      }
    };

    const result = defaultStats[gameType] || defaultStats.lotto;
    if (!result) {
      console.error(`❌ Brak domyślnych statystyk dla gry: ${gameType}`);
      return defaultStats.lotto;
    }
    return result;
  };

  // Funkcja do pobierania danych
  const fetchStats = useCallback(async (gameType) => {
    try {
      console.log(`🔄 fetchStats called with gameType: ${gameType}`);
      console.log(`🎯 Próbuję pobrać PRAWDZIWE dane ze scrapera dla gry: ${gameType}`);
      setLoading(true);
      setError(null);
      
      console.log(`🔄 Pobieranie statystyk dla gry: ${gameType}`);
      
      // Próbuj pobrać z backendu
      let timeoutId;
      try {
        const controller = new AbortController();
        timeoutId = setTimeout(() => controller.abort(), 30000); // Zwiększam timeout do 30 sekund
        
        const apiUrl = process.env.REACT_APP_IS_PWA === 'true' 
          ? 'https://us-central1-losujemy.cloudfunctions.net'
          : (process.env.REACT_APP_API_URL || 'https://us-central1-losujemy.cloudfunctions.net');
        
        let endpoint;
        if (activeTab === 'ai-algorithms') {
          // Użyj algorytmu codziennej zmiany liczb
          const dailyStats = generateDailyAIStats(gameType);
          setStats(dailyStats);
          setLastUpdated(dailyStats.lastUpdated);
          setDataSource({ source: 'daily-ai-algorithm' });
          return;
        } else if (activeTab === 'real') {
          endpoint = `/api/statistics/real/${gameType}`;
        } else {
          endpoint = `/api/statistics/ai/${gameType}`;
        }
        const fullUrl = `${apiUrl}${endpoint}`;
        console.log(`🌐 Próbuję pobrać dane z: ${fullUrl}`);
        
        const response = await fetch(fullUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        
        // Sprawdź czy zapytanie nie zostało anulowane
        if (controller.signal.aborted) {
          console.log('⚠️ Zapytanie zostało anulowane');
          return;
        }
        
        if (response.ok) {
          const result = await response.json();
          console.log(`📊 Backend response status: ${response.status}, data:`, result);
          
          if (result.success && result.statistics) {
            console.log('✅ Setting stats from backend:', result.statistics);
            console.log(`📊 Prawdziwe dane: totalDraws=${result.statistics.totalDraws}, source=${result.source}`);
            console.log(`🎉 SUKCES! Pobrano PRAWDZIWE dane ze scrapera!`);
            setStats(result.statistics);
            setLastUpdated(result.lastUpdated);
            setDataSource(result);
            console.log('✅ Stats state should be updated now');
            return;
          } else {
            console.log('❌ Backend response invalid:', result);
          }
        } else {
          console.log(`❌ Backend response not OK: ${response.status} ${response.statusText}`);
        }
      } catch (backendError) {
        if (timeoutId) {
          clearTimeout(timeoutId); // Wyczyść timeout w przypadku błędu
        }
        if (backendError.name === 'AbortError') {
          console.log('⚠️ Timeout - backend nie odpowiada po 30 sekundach, używam domyślnych danych');
        } else {
          console.log('⚠️ Backend niedostępny, używam domyślnych danych:', backendError.message);
          console.log('🔍 Szczegóły błędu:', backendError);
        }
      }
      
      // Fallback do domyślnych danych
      const defaultStats = getDefaultStats(gameType);
      if (defaultStats) {
        console.log('⚠️ Używam domyślnych statystyk (fallback) - to NIE są prawdziwe dane ze scrapera!');
        console.log(`📊 Domyślne dane: totalDraws=${defaultStats.totalDraws}, source=fallback`);
        setStats(defaultStats);
        setLastUpdated(new Date().toISOString());
        console.log('✅ Używam domyślnych statystyk');
      } else {
        console.error('❌ Nie udało się pobrać domyślnych statystyk');
        setError('Nie udało się załadować statystyk');
      }
      
    } catch (err) {
      console.error('❌ Błąd pobierania statystyk:', err);
      setError(err.message);
      
      // Fallback do domyślnych danych
      const defaultStats = getDefaultStats(gameType);
      if (defaultStats) {
        console.log('⚠️ Używam domyślnych statystyk (fallback) - to NIE są prawdziwe dane ze scrapera!');
        console.log(`📊 Domyślne dane: totalDraws=${defaultStats.totalDraws}, source=fallback`);
        setStats(defaultStats);
        setLastUpdated(new Date().toISOString());
      } else {
        console.error('❌ Nie udało się pobrać domyślnych statystyk');
        setError('Nie udało się załadować statystyk');
      }
    } finally {
      console.log('✅ fetchStats finally block - setting loading to false');
      setLoading(false);
    }
  }, []);

  // Funkcja do aktualizacji danych
  const updateStats = useCallback(async () => {
    try {
      setUpdating(true);
      console.log(`🔄 Aktualizuję statystyki dla gry: ${safeSelectedGame}`);
      
      // Próbuj aktualizować przez backend
      try {
        const apiUrl = process.env.REACT_APP_IS_PWA === 'true' 
          ? 'https://us-central1-losujemy.cloudfunctions.net'
          : (process.env.REACT_APP_API_URL || 'https://us-central1-losujemy.cloudfunctions.net');
        
        const response = await fetch(`${apiUrl}/api/statistics/update`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ gameType: safeSelectedGame })
        });
        
        if (response.ok) {
          const result = await response.json();
          
          if (result.success) {
            // Pobierz zaktualizowane dane
            await fetchStats(safeSelectedGame);
            alert(`✅ Statystyki dla ${gameNames[safeSelectedGame]} zostały zaktualizowane!`);
            return;
          }
        }
      } catch (backendError) {
        console.log('⚠️ Backend niedostępny');
      }
      
      // Fallback - odśwież domyślne dane
      const defaultStats = getDefaultStats(safeSelectedGame);
      setStats(defaultStats);
      setLastUpdated(new Date().toISOString());
      alert(`✅ Statystyki dla ${gameNames[safeSelectedGame]} zostały odświeżone!`);
      
    } catch (err) {
      console.error('❌ Błąd aktualizacji:', err);
      alert(`❌ Błąd aktualizacji: ${err.message}`);
    } finally {
      setUpdating(false);
    }
  }, [safeSelectedGame, fetchStats]);

  // Pobierz dane przy pierwszym załadowaniu i przy zmianie gry
  useEffect(() => {
    const loadData = async () => {
      console.log('🔄 FinalStatistics useEffect - selectedGame:', selectedGame, 'safeSelectedGame:', safeSelectedGame);
      console.log('🔄 FinalStatistics - Force loading stats immediately');
      await fetchStats(safeSelectedGame);
    };
    loadData();
  }, [safeSelectedGame, activeTab, fetchStats]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '24px', color: '#1976d2', marginBottom: '16px' }}>
          📊 Ładowanie statystyk...
        </div>
        <div style={{ 
          width: '50px', 
          height: '50px', 
          border: '4px solid #f3f3f3', 
          borderTop: '4px solid #1976d2', 
          borderRadius: '50%', 
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }}></div>
      </div>
    );
  }

  if (error && !stats) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '40px',
        background: '#ffebee',
        borderRadius: '16px',
        border: '2px solid #f44336'
      }}>
        <div style={{ fontSize: '24px', color: '#d32f2f', marginBottom: '16px' }}>
          ❌ Błąd ładowania
        </div>
        <div style={{ color: '#666', marginBottom: '16px' }}>
          {error}
        </div>
        <button
          onClick={() => fetchStats(safeSelectedGame)}
          style={{
            background: '#1976d2',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Spróbuj ponownie
        </button>
      </div>
    );
  }

  console.log('🔍 Render check - stats:', stats, 'loading:', loading, 'error:', error);
  
  if (!stats) {
    console.log('❌ No stats found - showing "Brak danych"');
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '24px', color: '#666' }}>
          Brak danych dla wybranej gry
        </div>
        <div style={{ fontSize: '14px', color: '#999', marginTop: '10px' }}>
          Debug: stats={JSON.stringify(stats)}, loading={loading}, error={error}
        </div>
      </div>
    );
  }

  const currentGame = gameNames[safeSelectedGame] || safeSelectedGame;
  
  // Sortuj liczby według częstotliwości
  const sortedFrequency = Object.entries(stats.frequencyData || {})
    .sort(([,a], [,b]) => b - a)
    .slice(0, 20);

  const infoButtonStyle = {
    background: 'linear-gradient(135deg, #2196F3, #1976D2)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: isSmallMobile ? 28 : 32,
    height: isSmallMobile ? 28 : 32,
    minWidth: isSmallMobile ? 28 : 32,
    maxWidth: isSmallMobile ? 28 : 32,
    minHeight: isSmallMobile ? 28 : 32,
    padding: 0,
    margin: 0,
    flexShrink: 0,
    cursor: 'pointer',
    fontSize: isSmallMobile ? 14 : 16,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(33, 150, 243, 0.3)',
  };

  return (
    <div style={containerStyle} className="final-statistics-root">
      <style>{`
        .final-statistics-root .stats-info-btn {
          width: ${isSmallMobile ? 28 : 32}px !important;
          min-width: ${isSmallMobile ? 28 : 32}px !important;
          max-width: ${isSmallMobile ? 28 : 32}px !important;
          height: ${isSmallMobile ? 28 : 32}px !important;
          min-height: ${isSmallMobile ? 28 : 32}px !important;
          padding: 0 !important;
          margin: 0 !important;
          flex-shrink: 0 !important;
        }
      `}</style>
      {/* Style CSS dla animacji */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      
      <h2 style={titleStyle}>
        📊 Statystyki historyczne - {currentGame}
        {lastUpdated && (
          <div style={{ fontSize: '14px', color: '#666', fontWeight: 'normal', marginTop: '8px' }}>
            Ostatnia aktualizacja: {new Date(lastUpdated).toLocaleString('pl-PL')}
          </div>
        )}
      </h2>
      
      {/* Wybór gry */}
      <div style={{ marginBottom: 24, textAlign: 'center' }}>
        <label style={{ fontWeight: "bold", marginRight: 10 }}>Wybierz grę:</label>
        <select
          value={safeSelectedGame}
          onChange={(e) => onGameChange(e.target.value)} 
          style={gameSelectStyle}
        >
          <option value="lotto">Lotto</option>
          <option value="miniLotto">Mini Lotto</option>
          <option value="multiMulti">Multi Multi</option>
          <option value="eurojackpot">Eurojackpot</option>
          <option value="kaskada">Kaskada</option>
          <option value="keno">Keno</option>
        </select>
      </div>

      {/* Zakładki typu danych */}
      <div style={{ 
        marginBottom: 24, 
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: 12,
        padding: 16,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div style={{ marginBottom: 12, fontWeight: 'bold', color: '#333' }}>
          📊 Typ danych statystycznych:
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => {
              setActiveTab('ai-algorithms');
              setStats(null);
              setLoading(true);
            }}
            style={{
              background: activeTab === 'ai-algorithms' ? 'linear-gradient(135deg, #FF9800, #F57C00)' : '#f5f5f5',
              color: activeTab === 'ai-algorithms' ? 'white' : '#333',
              border: 'none',
              borderRadius: 8,
              padding: '12px 20px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '14px',
              transition: 'all 0.3s ease',
              boxShadow: activeTab === 'ai-algorithms' ? '0 4px 12px rgba(255, 152, 0, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            🧠 AI Algorytmy
            <div style={{ fontSize: '11px', opacity: 0.9, marginTop: 2 }}>
              Codzienna inteligentna zmiana liczb + Typowanie AI
            </div>
          </button>
        </div>
        

      </div>
      
      {/* Informacje ogólne */}
      <div style={{ 
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", 
        color: "white", 
        borderRadius: 16, 
        padding: 20, 
        marginBottom: 24,
        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)"
      }}>
        <div style={{
          background: "#e8f5e8",
          border: "1px solid #4caf50",
          borderRadius: 8,
          padding: 12,
          marginBottom: 16,
          textAlign: "center"
        }}>
          <p style={{ margin: 0, color: "#2e7d32", fontSize: 14, fontWeight: "bold" }}>
            🤖 INTELIGENTNE SYMULACJE AI - CODZIENNIE NOWE LICZBY
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, gap: 12 }}>
          <h3 style={{ margin: 0, fontSize: isSmallMobile ? 16 : 20, flex: 1 }}>📈 Informacje ogólne</h3>
          <button
            type="button"
            className="stats-info-btn"
            onClick={() => setShowInfoPopup(true)}
            style={infoButtonStyle}
            title="Jak działa generator AI?"
            aria-label="Jak działa generator AI?"
          >
            ?
          </button>
        </div>
        <div style={statsGridStyle}>
          <div style={statCardStyle}>
            <h4 style={statTitleStyle}>Liczba losowań</h4>
            <p style={statValueStyle}>{stats.totalDraws?.toLocaleString() || '100'}</p>
            <p style={statDescriptionStyle}>Podstawa dla algorytmu AI</p>
          </div>
          <div style={statCardStyle}>
            <h4 style={statTitleStyle}>Średnia suma</h4>
            <p style={statValueStyle}>{stats.avgSum || 'Brak danych'}</p>
            <p style={statDescriptionStyle}>Typowy zakres sumy liczb</p>
          </div>
          <div style={statCardStyle}>
            <h4 style={statTitleStyle}>Zakres sumy</h4>
            <p style={statValueStyle}>
                          {stats.sumRange && stats.sumRange[0] !== null && stats.sumRange[1] !== null 
              ? `${stats.sumRange[0]} - ${stats.sumRange[1]}` 
              : 'Brak danych'}
            </p>
            <p style={statDescriptionStyle}>Najczęstszy zakres losowań</p>
          </div>
          <div style={statCardStyle}>
            <h4 style={statTitleStyle}>Status</h4>
            <p style={statValueStyle}>
              <span style={{ color: '#4caf50' }}>✅ Aktywne</span>
            </p>
            <p style={statDescriptionStyle}>Aktualny status gry.</p>
          </div>
        </div>
      </div>
      
      {/* Najczęściej losowane liczby */}
      <div style={sectionStyle}>
        <h3 style={{ ...sectionTitleStyle, color: "#2e7d32" }}>
          🔥 Najczęściej losowane liczby (TOP 10)
        </h3>
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", marginBottom: 16 }}>
          {sortedFrequency.slice(0, 10).map(([number, frequency], idx) => (
            <div key={number} style={{ 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              margin: "0 8px 8px 0",
              position: "relative"
            }}>
              <Ball n={parseInt(number)} highlight={idx < 3} />
              <div style={{ 
                fontSize: 12, 
                color: "#2e7d32", 
                fontWeight: "bold",
                marginTop: 4
              }}>
                {frequency}
              </div>
              {idx < 3 && (
                <div style={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  background: "#ff9800",
                  color: "white",
                  borderRadius: "50%",
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 10,
                  fontWeight: "bold"
                }}>
                  {idx + 1}
                </div>
              )}
            </div>
          ))}
        </div>
        <div style={{ 
          background: "#e8f5e8", 
          padding: 12, 
          borderRadius: 8, 
          fontSize: 14,
          color: "#2e7d32"
        }}>
          <strong>💡 Wskazówka:</strong> Liczby z najwyższą częstotliwością mają większą szansę na wylosowanie w przyszłości.
        </div>
      </div>
      
      {/* Najrzadziej losowane liczby */}
      <div style={sectionStyle}>
        <h3 style={{ ...sectionTitleStyle, color: "#f57c00" }}>
          ❄️ Najrzadziej losowane liczby (TOP 10)
        </h3>
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", marginBottom: 16 }}>
          {sortedFrequency.slice(-10).reverse().map(([number, frequency], idx) => (
            <div key={number} style={{ 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              margin: "0 8px 8px 0"
            }}>
              <Ball n={parseInt(number)} />
              <div style={{ 
                fontSize: 12, 
                color: "#f57c00", 
                fontWeight: "bold",
                marginTop: 4
              }}>
                {frequency}
              </div>
            </div>
          ))}
        </div>
        <div style={{ 
          background: "#fff3e0", 
          padding: 12, 
          borderRadius: 8, 
          fontSize: 14,
          color: "#f57c00"
        }}>
          <strong>💡 Wskazówka:</strong> Liczby z najniższą częstotliwością mogą "nadrobić" w przyszłości (prawo średniej).
        </div>
      </div>

      {/* Gorące i zimne liczby */}
      {stats.hotNumbers && stats.coldNumbers && (
        <div style={sectionStyle}>
          <h3 style={{ ...sectionTitleStyle, color: "#1976d2" }}>
            🌡️ Analiza trendów
          </h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 20 }}>
            <div>
              <h4 style={{ color: "#d32f2f", marginBottom: 12 }}>🔥 Gorące liczby (ostatnie 50 losowań)</h4>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {stats.hotNumbers.map((n, idx) => (
                  <div key={n} style={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center" 
                  }}>
                    <Ball n={n} size={40} />
                    <div style={{ fontSize: 10, color: "#d32f2f", fontWeight: "bold" }}>
                      HOT
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h4 style={{ color: "#1976d2", marginBottom: 12 }}>❄️ Zimne liczby (ostatnie 50 losowań)</h4>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {stats.coldNumbers.map((n, idx) => (
                  <div key={n} style={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center" 
                  }}>
                    <Ball n={n} size={40} />
                    <div style={{ fontSize: 10, color: "#1976d2", fontWeight: "bold" }}>
                      COLD
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Wzorce i analizy */}
      {stats.patterns && (
        <div style={sectionStyle}>
          <h3 style={{ ...sectionTitleStyle, color: "#9c27b0" }}>
            📊 Wzorce i analizy
          </h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
            <div style={{ 
              background: "#f3e5f5", 
              padding: 16, 
              borderRadius: 8,
              textAlign: "center"
            }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>⚖️</div>
              <strong>Parzyste:Nieparzyste</strong><br />
              <span style={{ fontSize: 18, color: "#9c27b0" }}>{stats.patterns.evenOdd}</span>
            </div>
            <div style={{ 
              background: "#e8f5e8", 
              padding: 16, 
              borderRadius: 8,
              textAlign: "center"
            }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>📈</div>
              <strong>Niskie:Wysokie</strong><br />
              <span style={{ fontSize: 18, color: "#2e7d32" }}>{stats.patterns.lowHigh}</span>
            </div>
            <div style={{ 
              background: "#fff3e0", 
              padding: 16, 
              borderRadius: 8,
              textAlign: "center"
            }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>🎯</div>
              <strong>Zakres sumy</strong><br />
              <span style={{ fontSize: 18, color: "#f57c00" }}>{stats.patterns.sumRange}</span>
            </div>
          </div>
        </div>
      )}
      

          


      {/* SEKCJA TYPOWANIA AI - NOWOCZESNY WYGLĄD */}
      {stats.aiTyping && (
        <div style={{ 
              background: "#ffffff", 
              borderRadius: 20, 
              padding: 24, 
              marginBottom: 24,
              textAlign: "center",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "3px solid #FFD700"
            }}>
              <h4 style={{ 
                margin: "0 0 20px 0", 
                fontSize: 24, 
                color: "#333",
                fontWeight: "bold",
                textShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}>
                🎯 TYPOWANIE AI - {currentGame.toUpperCase()}
              </h4>
              
              {/* Wyświetl liczby jako nowoczesne żółte kule z czarnymi liczbami */}
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                flexWrap: "wrap", 
                gap: 16, 
                marginBottom: 24,
                padding: "20px 0"
              }}>
                {stats.aiTyping.numbers.map((num, idx) => (
                  <div key={num} style={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    background: "#FFD700",
                    border: "3px solid #FFA500",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                    color: "#000000",
                    boxShadow: "0 4px 12px rgba(255, 215, 0, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.3)",
                    position: "relative",
                    transition: "all 0.3s ease",
                    cursor: "pointer"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.1)";
                    e.target.style.boxShadow = "0 8px 25px rgba(255, 215, 0, 0.7), inset 0 2px 4px rgba(255, 255, 255, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)";
                    e.target.style.boxShadow = "0 6px 20px rgba(255, 215, 0, 0.5), inset 0 2px 4px rgba(255, 255, 255, 0.3)";
                  }}
                  >
                    <span style={{ 
                      position: "absolute", 
                      top: 6, 
                      left: 10, 
                      width: 18, 
                      height: 12, 
                      borderRadius: "50%", 
                      background: "rgba(255,255,255,0.6)", 
                      filter: "blur(1px)" 
                    }}></span>
                    <span style={{ position: "relative", zIndex: 2 }}>{num}</span>
                  </div>
                ))}
              </div>
              
              {/* Wyświetl liczby Euro dla Eurojackpot */}
              {stats.aiTyping.euroNumbers && (
                <div style={{ 
                  display: "flex", 
                  justifyContent: "center", 
                  flexWrap: "wrap", 
                  gap: 16, 
                  marginBottom: 24,
                  padding: "10px 0"
                }}>
                  <div style={{ 
                    fontSize: 16, 
                    fontWeight: "bold", 
                    color: "#333", 
                    marginRight: 16,
                    alignSelf: "center"
                  }}>
                    🇪🇺 Euro:
                  </div>
                  {stats.aiTyping.euroNumbers.map((num, idx) => (
                    <div key={`euro-${num}`} style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#4CAF50",
                      border: "3px solid #2E7D32",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      boxShadow: "0 4px 12px rgba(76, 175, 80, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.3)",
                      position: "relative",
                      transition: "all 0.3s ease",
                      cursor: "pointer"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.1)";
                      e.target.style.boxShadow = "0 6px 20px rgba(76, 175, 80, 0.6), inset 0 2px 4px rgba(255, 255, 255, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                      e.target.style.boxShadow = "0 4px 12px rgba(76, 175, 80, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.3)";
                    }}
                    >
                      <span style={{ 
                        position: "absolute", 
                        top: 4, 
                        left: 8, 
                        width: 14, 
                        height: 10, 
                        borderRadius: "50%", 
                        background: "rgba(255,255,255,0.4)", 
                        filter: "blur(1px)" 
                      }}></span>
                      <span style={{ position: "relative", zIndex: 2 }}>{num}</span>
                    </div>
                  ))}
                </div>
              )}
              
              {/* Informacje o typowaniu - nowoczesny design */}
              <div style={{ 
                display: "grid", 
                gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", 
                gap: 20, 
                marginBottom: 24 
              }}>
                <div style={{ 
                  background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)", 
                  padding: 16, 
                  borderRadius: 12,
                  textAlign: "center",
                  border: "2px solid #FFD700",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
                }}>
                  <div style={{ fontSize: 14, color: "#666", marginBottom: 8, fontWeight: "600" }}>Suma liczb</div>
                  <div style={{ fontSize: 24, fontWeight: "bold", color: "#333" }}>
                    {stats.aiTyping.sum}
                  </div>
                </div>
                
                <div style={{ 
                  background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)", 
                  padding: 16, 
                  borderRadius: 12,
                  textAlign: "center",
                  border: "2px solid #FFD700",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
                }}>
                  <div style={{ fontSize: 14, color: "#666", marginBottom: 8, fontWeight: "600" }}>Zakres docelowy</div>
                  <div style={{ fontSize: 24, fontWeight: "bold", color: "#333" }}>
                    {stats.aiTyping.targetRange[0]}-{stats.aiTyping.targetRange[1]}
                  </div>
                </div>
                
                <div style={{ 
                  background: stats.aiTyping.inRange 
                    ? "linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)" 
                    : "linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)", 
                  padding: 16, 
                  borderRadius: 12,
                  textAlign: "center",
                  border: stats.aiTyping.inRange ? "2px solid #28a745" : "2px solid #dc3545",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
                }}>
                  <div style={{ fontSize: 14, color: "#666", marginBottom: 8, fontWeight: "600" }}>Status</div>
                  <div style={{ fontSize: 20, fontWeight: "bold", color: stats.aiTyping.inRange ? "#155724" : "#721c24" }}>
                    {stats.aiTyping.inRange ? "✅ W zakresie" : "⚠️ Poza zakresem"}
                  </div>
                </div>
              </div>
              
              {/* Opis jak działa typowanie - nowoczesny design */}
              <div style={{ 
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)", 
                padding: 20, 
                borderRadius: 16,
                fontSize: 16,
                color: "#333",
                textAlign: "left",
                border: "2px solid #FFD700",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
              }}>
                <strong style={{ fontSize: 18, color: "#333" }}>🧠 Jak działa typowanie AI:</strong>
                <ul style={{ margin: "12px 0 0 0", paddingLeft: "24px", lineHeight: "1.6" }}>
                  <li>Analizuje <strong>najszczęśliwsze liczby</strong> (najwyższe częstotliwości)</li>
                  <li>Generuje kombinację w <strong>docelowym zakresie sumy</strong></li>
                  <li>Liczby zmieniają się <strong>każdego dnia</strong> o północy</li>
                  <li>Bazuje na <strong>100 losowaniach</strong> jako podstawa statystyczna</li>
                </ul>
              </div>
            </div>
          )}
      

      
      {/* Wykres częstotliwości */}
      <div style={sectionStyle}>
        <h3 style={{ ...sectionTitleStyle, color: "#607d8b" }}>
          📊 Wykres częstotliwości (TOP 15)
        </h3>
        <div style={{ 
          display: "grid", 
          gridTemplateColumns: "repeat(auto-fit, minmax(40px, 1fr))", 
          gap: 8,
          maxWidth: "100%",
          overflowX: "auto"
        }}>
          {sortedFrequency.slice(0, 15).map(([number, frequency], idx) => {
            const maxFreq = sortedFrequency[0][1];
            const height = (frequency / maxFreq) * 100;
            return (
              <div key={number} style={{ 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center",
                minHeight: 120
              }}>
                <div style={{ 
                  width: "100%", 
                  height: `${height}px`,
                  background: `linear-gradient(to top, ${idx < 5 ? '#4caf50' : idx < 10 ? '#ff9800' : '#f44336'}, ${idx < 5 ? '#66bb6a' : idx < 10 ? '#ffb74d' : '#ef5350'})`,
                  borderRadius: "4px 4px 0 0",
                  marginBottom: 8,
                  minHeight: 20
                }}></div>
                <div style={{ 
                  fontSize: 12, 
                  fontWeight: "bold",
                  color: "#607d8b",
                  textAlign: "center"
                }}>
                  {number}
                </div>
                <div style={{ 
                  fontSize: 10, 
                  color: "#999",
                  textAlign: "center"
                }}>
                  {frequency}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      {/* Przyciski aktualizacji */}
      <div style={sectionStyle}>
        <h3 style={{ ...sectionTitleStyle, color: "#2196f3" }}>
          🔄 Aktualizacja danych
        </h3>
        
        {/* Komunikat o aktualizacji */}
        {updating && (
          <div style={{
            background: "linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)",
            border: "2px solid #ffc107",
            borderRadius: "12px",
            padding: "16px",
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px"
          }}>
            <div style={{
              width: "24px",
              height: "24px",
              border: "3px solid #ffc107",
              borderTop: "3px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite"
            }}></div>
            <span style={{ 
              fontSize: "16px", 
              fontWeight: "bold", 
              color: "#856404" 
            }}>
              Aktualizuję statystyki dla {currentGame}...
            </span>
          </div>
        )}
        
        <div style={{ textAlign: "center" }}>
          <button 
            onClick={updateStats}
            disabled={updating}
            style={buttonStyle}
          >
            {updating ? (
              <>
                <div style={{
                  display: "inline-block",
                  width: "16px",
                  height: "16px",
                  border: "2px solid #ffffff",
                  borderTop: "2px solid transparent",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  marginRight: "8px"
                }}></div>
                Aktualizuję...
              </>
            ) : (
              `🔄 Aktualizuj ${currentGame}`
            )}
          </button>
        </div>
        
        <div style={{ 
          background: "#e3f2fd", 
          padding: 12, 
          borderRadius: 8, 
          fontSize: 14,
          color: "#1976d2",
          marginTop: 16
        }}>
          <strong>ℹ️ Informacja:</strong> Statystyki są automatycznie aktualizowane co godzinę. 
          Możesz też ręcznie zaktualizować dane używając powyższego przycisku.
        </div>
      </div>
      
      {/* Popup informacyjny - Jak działa generator AI */}
      {showInfoPopup && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          padding: "20px"
        }}>
          <div style={{
            background: "white",
            borderRadius: "16px",
            padding: "24px",
            maxWidth: "600px",
            maxHeight: "80vh",
            overflow: "auto",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)"
          }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}>
              <h2 style={{ margin: 0, color: "#2196F3" }}>🧠 Jak działa generator AI?</h2>
              <button
                onClick={() => setShowInfoPopup(false)}
                style={{
                  background: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  cursor: "pointer",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                ×
              </button>
            </div>
            
            <div style={{ lineHeight: "1.6", color: "#333" }}>
              <h3 style={{ color: "#FF9800", marginTop: "20px" }}>🎯 Podstawy działania:</h3>
              <ul style={{ paddingLeft: "20px" }}>
                <li><strong>100 losowań jako podstawa</strong> - algorytm generuje liczby na podstawie analizy 100 losowań</li>
                <li><strong>Codzienna zmiana</strong> - każdego dnia o północy generowane są nowe liczby</li>
                <li><strong>Deterministyczne</strong> - te same liczby dla tego samego dnia (na podstawie daty)</li>
                <li><strong>Inteligentne</strong> - uwzględnia wszystkie praktyczne statystyki lotto</li>
              </ul>
              
              <h3 style={{ color: "#4CAF50", marginTop: "20px" }}>📊 Co uwzględnia generator:</h3>
              <ul style={{ paddingLeft: "20px" }}>
                <li><strong>Praktyczne zakresy sum</strong> - liczby zawsze mieszczą się w realistycznych przedziałach</li>
                <li><strong>Rozkład parzyste/nieparzyste</strong> - zgodny z rzeczywistymi statystykami</li>
                <li><strong>Maksymalne luki</strong> - unika serii po 5+ kolejnych liczb</li>
                <li><strong>Rozkład na dziesiątki</strong> - realistyczny podział zakresów</li>
                <li><strong>Wzorce par i trójek</strong> - analiza kombinacji liczb</li>
              </ul>
              
              <h3 style={{ color: "#9C27B0", marginTop: "20px" }}>🎲 Zakresy sum dla gier:</h3>
              <ul style={{ paddingLeft: "20px" }}>
                <li><strong>LOTTO:</strong> 110-190 (80% losowań)</li>
                <li><strong>MINI LOTTO:</strong> 80-140 (80% losowań)</li>
                <li><strong>MULTI MULTI:</strong> 650-950 (rozrzut ±150)</li>
                <li><strong>EUROJACKPOT:</strong> 110-180 (główne + gwiazdy)</li>
                <li><strong>KENO:</strong> 600-820 (rozrzut ±110)</li>
              </ul>
              
              <h3 style={{ color: "#2196F3", marginTop: "20px" }}>💡 Jak korzystać:</h3>
              <ul style={{ paddingLeft: "20px" }}>
                <li><strong>Zakładka "Inteligentne symulacje AI"</strong> - podstawowe statystyki</li>
                <li><strong>Zakładka "AI Algorytmy"</strong> - zaawansowane statystyki i wygenerowane liczby</li>
                <li><strong>Codzienne sprawdzanie</strong> - liczby zmieniają się każdego dnia</li>
                <li><strong>Analiza wzorców</strong> - wykorzystaj statystyki do własnych strategii</li>
              </ul>
              
              <h3 style={{ color: "#FF5722", marginTop: "20px" }}>⚠️ Ważne informacje:</h3>
              <ul style={{ paddingLeft: "20px" }}>
                <li><strong>To nie są prawdziwe wyniki</strong> - to inteligentne symulacje AI</li>
                <li><strong>Nie gwarantują wygranej</strong> - służą do analizy i strategii</li>
                <li><strong>Bazują na statystykach</strong> - wykorzystują prawdziwe wzorce lotto</li>
                <li><strong>Codzienna aktualizacja</strong> - zawsze świeże dane</li>
              </ul>
            </div>
            
            <div style={{
              marginTop: "24px",
              padding: "16px",
              background: "#e3f2fd",
              borderRadius: "8px",
              border: "1px solid #2196F3"
            }}>
              <strong>🎉 Gotowe!</strong> Generator AI jest gotowy do użycia. 
              Przełącz między zakładkami, aby zobaczyć różne poziomy analizy i wygenerowane liczby.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinalStatistics;

